document.querySelectorAll('marmeto-product-card').forEach((card) => {
  card.addEventListener("click", function (event) {
    // Check if the clicked element is an input inside .varcustom-Type or .varcustom-Style
    if (event.target.matches(".varcustom-Type input, .input-label")) {
        setTimeout(function () {
            // Find the closest mm-variant-radios container
            const variantRadios = event.target.closest("mm-variant-radios");
  

            if (!variantRadios) {
                console.warn("Variant radio container not found.");
                return;
            }

            // Locate the color swatch within the identified variant radios
            const colorSwatch = variantRadios.querySelector(".varcustom-Color .color_swatch__container .new-wrap-label");
            if (!colorSwatch) {
                console.warn("Color swatch not found.");
                return; // Exit if not found
            }else{
                colorSwatch.click();  
            }
        }, 1500);
    }
});
})